import { createApp } from 'vue';
import externalReserveButton from '../vue-component/externalReserveButton.vue';
import reserveForm from '../vue-component/reserveForm.vue';

const app = createApp({});
app.component('reserveform', reserveForm);
app.mount('#form')

const app2 = createApp({});
app2.component('external-reserve-button', externalReserveButton);
app2.mount('#external_reserve_button')

